export const LOGROCKET_APP_ID = 'gd5q2i/autoroster'
